import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 34, height: 34, viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 17, cy: 17, r: 17, fill: "#4DAA57" }), /* @__PURE__ */ React.createElement("path", { d: "M10.1426 18.498L14.6101 23.2507L19.3627 18.4981L25.247 12.6139", stroke: "white", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
